import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Rodal from 'rodal'
import ContactUsForm from './ContactUsForm'
import * as contactUsDuck from '../contactUsDuck'
import selectors from '../../../../store/shared/selectors'

export class ContactUsModal extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isShowingModal: PropTypes.bool.isRequired,
  }

  render() {
    const {
      closeModal,
      isMobile,
      isShowingModal,
    } = this.props

    return (
      <Rodal
        visible={isShowingModal}
        measure="%"
        width={isMobile ? 90 : 70}
        height={isMobile ? 90 : 70}
        customMaskStyles={{ opacity: 0.5, backgroundColor: 'black' }}
        closeOnEsc
        onClose={closeModal}
        duration={100}
      >
        <div style={{ overflowY: 'auto', height: '100%' }}>
          <div className="text-center">
            <h4>Contact Us</h4>
            <h5>Your feedback will help us serve you better</h5>
          </div>
          <div style={{ marginLeft: 10, marginRight: 10 }}>
            <ContactUsForm/>
          </div>
        </div>
      </Rodal>
    )
  }
}

const mapStateToProps = state => ({
  isShowingModal: contactUsDuck.getIsShowingModal(state),
  isMobile: selectors.isLessThanMedium(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeModal: contactUsDuck.closeModal,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsModal)



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/components/ContactUsModal.js